import { useEffect, type FC } from 'react'

import type { FreeGuidesLandingPageRecord } from '@/graphql/FreeGuidesLandingPage'

import { Footer } from '@/components/elements/footer/Footer'
import { Header } from '@/components/elements/header/Header'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

import { trackLandingViewEvent } from '@/lib/gtm/gtmV2'

import { FreeGuidesLandingPageContent } from './FreeGuideLandingPageContent'
import { FreeGuideLandingPageHeroSection } from './FreeGuideLandingPageHeroSection'

type FreeGuidesLandingPageProps = {
  page: FreeGuidesLandingPageRecord
}

export const FreeGuideLandingPage: FC<FreeGuidesLandingPageProps> = ({ page }) => {
  const { content, metaData, pageTitle } = page

  useEffect(() => {
    trackLandingViewEvent('free_guide', pageTitle, 'v1')
  }, [])

  return (
    <>
      <SEOMetaTags metaData={metaData} />

      <Header />

      <main id="main-content" style={{ backgroundColor: '#FBF8F3' }}>
        <FreeGuideLandingPageHeroSection />
        <FreeGuidesLandingPageContent content={content} />
      </main>

      <Footer />
    </>
  )
}
